// src/components/operationCenter/widgets/token/valuation/TwMcFeesHistoryWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import McFeesHistoryChart from "@/components/tokenPage/valuation/McFeesHistoryChart";

const TwMcFeesHistoryWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["fundamentals"]}>
        <McFeesHistoryChart />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwMcFeesHistoryWidget;
